import { render, staticRenderFns } from "./YesOrNo.vue?vue&type=template&id=87fa8614"
import script from "./YesOrNo.vue?vue&type=script&lang=js"
export * from "./YesOrNo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports